import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/owner"} replace />;
  }

  async function onSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const next = await login(email, password);
      navigate(next.role === "admin" ? "/admin" : "/owner");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <PublicLayout>
      <div className="mx-auto grid w-full max-w-6xl flex-1 items-center gap-10 px-4 py-12 sm:px-6 lg:grid-cols-2 lg:px-8">
        <div className="overflow-hidden rounded-[2rem] bg-plum p-8 text-cream shadow-glow sm:p-12">
          <p className="text-xs uppercase tracking-[0.24em] text-gold">Aurelia studio</p>
          <h1 className="mt-4 font-serif text-5xl">Sign in to your house.</h1>
          <p className="mt-4 text-cream/75">
            Admins open the atelier. Hotel owners dress their own page, rooms
            and reservation book.
          </p>
        </div>
        <form onSubmit={onSubmit} className="card p-8">
          <label className="label">Email</label>
          <input
            type="email"
            className="field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label className="label mt-4">Password</label>
          <input
            type="password"
            className="field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="mt-3 text-sm text-rose">{error}</p>}
          <button className="btn-ink mt-6 w-full" disabled={busy}>
            {busy ? "Opening…" : "Enter Aurelia"}
          </button>
        </form>
      </div>
    </PublicLayout>
  );
}
